var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notfound"},[_vm._v(" Page lost! "),_c('form-create',{attrs:{"option":_vm.option,"rule":_vm.rules}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }